var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIconPopup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 20851"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 15C1 7.26802 7.26802 1 15 1C22.732 1 29 7.26802 29 15C29 22.732 22.732 29 15 29C7.26802 29 1 22.732 1 15Z",
    stroke: "#1B224C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.3335 10.3333L19.6668 19.6666M19.6668 10.3333L10.3335 19.6666",
    stroke: "#1B224C",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconPopup);
export default __webpack_public_path__ + "static/media/deleteIconPopup.6f99fa77213b96c9eaeac3d08d60dcb1.svg";
export { ForwardRef as ReactComponent };